import axiosInstance from "../../api/axiosInstance";

export const fetchTournamentTablesByIdAPI = async (tournamentId, filters = {}) => {
  const tournamentTables = await axiosInstance.get(
    `tables/find-all-tournament-tables/${tournamentId}`,
    {
      params: filters,
    },
  );

  return tournamentTables.data;
};

export const syncTournamentTablesByIdAPI = async ({
  tournamentId,
  filters = {},
  since = "",
  knownTableIds = [],
}) => {
  const params = {
    ...filters,
    since,
    knownTableIds: knownTableIds.join(","),
  };

  const tournamentTables = await axiosInstance.get(
    `tables/sync-tournament-tables/${tournamentId}`,
    {
      params,
    },
  );

  return tournamentTables.data;
};

export const fetchRoomInformationEfficiencyAPI = async (tournamentId) => {
  const response = await axiosInstance.get("tables/room-information-efficiency", {
    params: tournamentId ? { tournamentId } : {},
  });

  return response.data;
};

export const createTableAPI = async (tableData) => {
  const newTable = await axiosInstance.post("tables/create-table", tableData);

  return newTable.data;
};

export const createNextStageTablesAPI = async ({
  tournamentId,
  targetTableCount = 15,
  playersLimit = 60,
}) => {
  const response = await axiosInstance.post(
    `tables/create-next-stage-tables-v2/${tournamentId}`,
    {
      targetTableCount,
      playersLimit,
    },
  );

  return response.data;
};

export const deleteTableAPI = async (tableId) => {
  const response = await axiosInstance.delete(`tables/delete-table/${tableId}`);

  return response.data;
};

export const upsertTableRoomInformationAPI = async ({
  tournamentId,
  tableId,
  roomInfo,
}) => {
  const response = await axiosInstance.put(
    `tables/${tournamentId}/table-room-information/${tableId}`,
    { roomInfo },
  );

  return response.data;
};

export const upsertTableRoomTimeAPI = async ({
  tournamentId,
  tableId,
  eventAtUtc,
  date,
  timelineSlot,
}) => {
  const response = await axiosInstance.put(
    `tables/${tournamentId}/table-room-time/${tableId}`,
    { eventAtUtc, date, timelineSlot },
  );

  return response.data;
};

export const fetchAvailableTimelinesAPI = async (tournamentId) => {
  const response = await axiosInstance.get(
    `tables/${tournamentId}/available-timelines`,
  );

  return response.data;
};
